import 'bootstrap/js/dist/scrollspy';